module.exports = __webpack_public_path__ + "img/addlist.7d69a81c.png";